import React from 'react'
import { Card, CardContent, Grid, Typography, Checkbox, Button } from '@material-ui/core'
import ChevronRight from '@material-ui/icons/ChevronRight'
import { getDaysLabel } from 'lib/utils'
import { useHomeStore } from 'context/HomeStore'
import { useRoutes } from 'lib/hooks'
import { CONTRACT_PATH } from 'routes/constants.routes'
import { AsterChip } from 'asterX-UI/Chip'
import { getStatusColor, getStatusLabel } from 'lib/constants/deals'
import { useAuthStore } from 'context/AuthStore'
import { useStyles } from './contract-card.styles'

const ContractCard = ({ item, page = 'home' }) => {
  const classes = useStyles()
  const routes = useRoutes()
  const { authStoreFunc } = useAuthStore()
  const { homeStore, homeStoreFunc } = useHomeStore()
  const isSelected = homeStore.selectedRows.includes(item?.id)

  const handleOpenContract = id => {
    if (id) {
      routes.goTo(`${CONTRACT_PATH}/${id}`)
    }
  }

  return (
    <Card key={item?.id} className={classes.card}>
      <CardContent className={classes.cardContent}>
        <Grid container spacing={2}>
          <Grid item xs={12} className={classes.cardCheckbox}>
            {authStoreFunc.isAdmin() && (
              <Checkbox
                name={`contractNumber-${item?.id}`}
                onChange={() => homeStoreFunc?.handleRowCheckboxChange(item?.id)}
                checked={isSelected}
                id={`contractNumber-${item?.id}`}
                color={'primary'}
                style={{ padding: 0 }}
              />
            )}
            <Typography variant="body2" className={classes.contractNumber}>
              <strong>№{item?.contractNumber}</strong>
            </Typography>
            <AsterChip style={{ marginLeft: 'auto' }} label={item?.overdueType} />
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body2">
              <strong>Клиент:</strong> {item?.clientFullName?.replace('null', '').trim() || '-'}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body2">
              <strong>Филиал shinhan:</strong> {item?.subdivisionName}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body2">
              <strong>Продукт:</strong> {item?.creditProductName}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body2">
              <strong>Дни просрочки:</strong> {`${item?.overdueDays || 0} ${getDaysLabel(item?.overdueDays)}`}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body2">
              <strong>Сумма займа:</strong> {item?.loanAmount?.toString()?.thousandSeparator()}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body2">
              <strong>Сумма просрочки:</strong> {item?.overdueTranchesSum?.toString()?.thousandSeparator()}
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <Typography variant="body2">
              <strong>Статус: </strong>{' '}
              <AsterChip
                label={item?.statusName || getStatusLabel(item?.workListStatusCode) || 'Новый'}
                style={getStatusColor(item?.statusCode || item?.workListStatusCode || 'Новый')}
              />
            </Typography>
          </Grid>
          {authStoreFunc.isAdmin() && page === 'tasks' && (
            <Grid item xs={12}>
              <Typography variant="body2">
                <strong>У менеджера:</strong>{' '}
                {`${item?.lastAssignChangeDays || 0} ${getDaysLabel(item?.lastAssignChangeDays)}`}
              </Typography>
            </Grid>
          )}
          <Grid item xs={12}>
            <Button fullWidth variant="outlined" onClick={() => handleOpenContract(item?.id)}>
              Перейти
              <ChevronRight />
            </Button>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  )
}

export default ContractCard
